// extracted by mini-css-extract-plugin
export var backTo = "CruiseInfoSummary2-module--back-to--a5930";
export var backToDestinationTag = "CruiseInfoSummary2-module--back-to-destination-tag--0a86d";
export var cruiseCode = "CruiseInfoSummary2-module--cruise-code--6055c";
export var cruiseExpedition = "CruiseInfoSummary2-module--cruise-expedition--d9f52";
export var cruiseName = "CruiseInfoSummary2-module--cruise-name--d1b74";
export var cruisePagination = "CruiseInfoSummary2-module--cruise-pagination--8a7ab";
export var cruisePaginationLabel = "CruiseInfoSummary2-module--cruise-pagination-label--7253a";
export var cruiseRecap = "CruiseInfoSummary2-module--cruise-recap--85c11";
export var ctaButtons = "CruiseInfoSummary2-module--cta-buttons--ceb2a";
export var ctaContainers = "CruiseInfoSummary2-module--cta-containers--d2577";
export var facebookShareButton = "CruiseInfoSummary2-module--facebook-share-button--98f52";
export var featuresContainer = "CruiseInfoSummary2-module--features-container--af8c4";
export var featuresContainerPlaceholder = "CruiseInfoSummary2-module--features-container-placeholder--cf1f9";
export var featuresList = "CruiseInfoSummary2-module--features-list--4af0a";
export var map = "CruiseInfoSummary2-module--map--3a237";
export var mapContainer = "CruiseInfoSummary2-module--map-container--5bd95";
export var pdfButton = "CruiseInfoSummary2-module--pdf-button--2d0a4";
export var price = "CruiseInfoSummary2-module--price--317b8";
export var priceRecap = "CruiseInfoSummary2-module--price-recap--155e3";
export var promoBadges = "CruiseInfoSummary2-module--promo-badges--35d29";
export var promoBadgesContainer = "CruiseInfoSummary2-module--promo-badges-container--66fc3";
export var promoBadgesTitle = "CruiseInfoSummary2-module--promo-badges-title--d13ea";
export var root = "CruiseInfoSummary2-module--root--e5c69";
export var serviceButtons = "CruiseInfoSummary2-module--service-buttons--1ccd8";
export var specialVoyageRoot = "CruiseInfoSummary2-module--specialVoyageRoot--ec308";
export var titleInfo = "CruiseInfoSummary2-module--title-info--082ec";